import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';

function* getSettings() {
  try {
    const { data } = yield call(fetch, { api: api.settings, pub: true, useV1: true });

    yield put(actions.getSettingsDone(data));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getSettingsFailed,
      endpoint: api.settings.url
    });
  }
}

export const getSettingsSaga = takeEvery(types.GET_SETTINGS_REQUEST, getSettings);